export default {"src":"/_next/static/media/Pennsylvania.09e5a2dc.svg","height":350,"width":800,"blurWidth":0,"blurHeight":0};